/* ============================================================
   Collection Page — filter panel + AJAX sort + Load More.
   Vanilla JS. Uses same style as theme.js.
   ============================================================ */
(function () {
  'use strict';

  function initFilterToggle() {
    var btn = document.querySelector('[data-filter-toggle]');
    var panel = document.querySelector('[data-filter-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = !panel.hasAttribute('hidden');
      if (isOpen) {
        panel.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  // Chip labels toggle checkbox state (checkbox is visually hidden)
  function initChipLabels() {
    document.querySelectorAll('.filter-chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        chip.classList.toggle('is-active', input.checked);
      });
    });
  }

  // Sort dropdown — submit filter form so params merge
  function initSort() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', select.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }

  // Load more — appends next page into grid via fetch
  function initLoadMore() {
    var btn = document.querySelector('[data-load-more]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;
      var url = btn.getAttribute('href');
      btn.classList.add('is-loading');
      btn.querySelector('span').textContent = 'Loading…';

      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-products-grid]');
          var newBtn = doc.querySelector('[data-load-more]');
          var currentGrid = document.querySelector('[data-products-grid]');
          if (newGrid && currentGrid) {
            var startIndex = currentGrid.children.length;
            Array.prototype.forEach.call(newGrid.children, function (cell, i) {
              cell.style.setProperty('--i', startIndex + i);
              currentGrid.appendChild(cell);
            });
          }
          if (newBtn) {
            btn.setAttribute('href', newBtn.getAttribute('href'));
            btn.querySelector('span').textContent = 'Load more';
            btn.classList.remove('is-loading');
          } else {
            btn.remove();
          }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.querySelector('span').textContent = 'Load more';
        });
    });
  }

  // Reuse the homepage hero floaters generator for the collection hero.
  // (theme.js already runs initHeroFloaters on DOMContentLoaded, which
  //  targets [data-hero-floaters] — our hero uses the same hook, so it
  //  will be populated automatically. This is a no-op safety net.)
  function ensureHeroFloaters() {
    var container = document.querySelector('.collection-hero [data-hero-floaters]');
    if (!container || container.children.length > 0) return;
    var colors = ['#e879a8', '#f5a623'];
    for (var i = 0; i < 16; i++) {
      var dot = document.createElement('span');
      dot.className = 'hero__floater';
      var size = (i % 3) * 3 + 4;
      dot.style.position = 'absolute';
      dot.style.borderRadius = '9999px';
      dot.style.width = size + 'px';
      dot.style.height = size + 'px';
      dot.style.background = i % 2 === 0 ? colors[0] : colors[1];
      dot.style.opacity = '0.25';
      dot.style.top = ((i * 17 + 5) % 100) + '%';
      dot.style.left = ((i * 23 + 10) % 100) + '%';
      dot.style.animation = 'float ' + ((i % 3) * 2 + 4) + 's ease-in-out infinite';
      dot.style.animationDelay = (i % 4) + 's';
      container.appendChild(dot);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFilterToggle();
    initChipLabels();
    initSort();
    initLoadMore();
    // Slight delay so theme.js runs its initHeroFloaters first
    setTimeout(ensureHeroFloaters, 100);
  });
})();
